import React from 'react'
import { Route, Link } from 'react-router-dom';
import Collapse from '@material-ui/core/Collapse';
import Icon from '../Icons/Icon'
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import List from '@material-ui/core/List';


const LinksGroup = ({ childrenLinks, headerLink, header, iconName, panel }) => {
  const [open, setOpen] = React.useState(false);
  const handleClick = () => {
    setOpen(!open);
  };

  if (!childrenLinks) {
    return (
      <ListItem button component={Link} to={headerLink}>
         <ListItemIcon><Icon icon={iconName} customClass="ift20 space-right" /></ListItemIcon>  <ListItemText primary={header} />
      </ListItem>
    );
  }
  return (
    <Route
      path={headerLink}
      children={({ match }) => {
        return (
          <>
            <ListItem button onClick={handleClick}>
              <ListItemIcon> <Icon icon={iconName} customClass="ift20 space-right"/></ListItemIcon><ListItemText primary={header} />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>

                {childrenLinks &&
                  childrenLinks.map(child => (
                    <ListItem key={child.name} button className={`nested`} component={Link} to={child.link}>
                      <ListItemIcon>
                        <FiberManualRecordIcon />
                      </ListItemIcon>
                      <ListItemText primary={child.name} />
                    </ListItem>
                  ))}
              </List>
            </Collapse>
          </>
        );
      }}
    />
  );
}

export default LinksGroup
